// Constants outside the class
const POPUP_MUTED_STORAGE_KEY = "popup-muted"

class GenericPopup extends HTMLElement {
  localStorageKey: string = this.id + "-" + POPUP_MUTED_STORAGE_KEY

  constructor() {
    super()
  }

  connectedCallback() {
    // Don't show popup when storage key exists
    const disableOnStorageKey = this.dataset.disableOnStorageKey
    if (disableOnStorageKey) {
      const storageKey = localStorage.getItem(disableOnStorageKey)
      if (storageKey === "true") {
        return
      }
    }

    const popupDelay = this.dataset.popupDelay
      ? Number(this.dataset.popupDelay)
      : null

    const mutedUntil = localStorage.getItem(this.localStorageKey)
    const now = new Date().getTime()

    if (mutedUntil && Number(mutedUntil) > now) {
      // Popup is still muted, do not show
      return
    }

    // If not muted, set a timeout to show the popup
    if (popupDelay !== null) {
      setTimeout(() => {
        this.showPopup()
      }, popupDelay * 1000)
    }

    const closeButton = this.querySelector(".generic-popup__close")
    if (closeButton) {
      closeButton.addEventListener("click", this.hidePopup)
    }

    const backdrop = this.querySelector(".generic-popup__backdrop")
    if (backdrop) {
      backdrop.addEventListener("click", this.hidePopup)
    }
  }

  showPopup = () => {
    this.classList.add("is-visible")
  }

  hidePopup = () => {
    this.classList.remove("is-visible")

    // If mute duration is set, mute the popup
    const mutePopupDuration = Number(this.dataset.mutePopup || "0") // Duration in days
    if (mutePopupDuration > 0) {
      const muteUntil =
        new Date().getTime() + mutePopupDuration * 24 * 60 * 60 * 1000

      localStorage.setItem(this.localStorageKey, muteUntil.toString())
    }
  }
}

customElements.define("generic-popup", GenericPopup)
